export const ALLOCATION_COLORS = [
  "#33B4BD",
  "#FE8C42",
  "#FF66A3",
  "#FED401",
  "#0068FF",
  "#11BF68",
  "#877EE7",
  "#E92E4A",
];

const SATURATION_STEP = 32;
const LIGHTNESS_STEP = 6;
const MIN_SATURATION = 15;
const MIN_LIGHTNESS = 25;

function hexToHsl(hex: string): { h: number; s: number; l: number } {
  const r = parseInt(hex.slice(1, 3), 16) / 255;
  const g = parseInt(hex.slice(3, 5), 16) / 255;
  const b = parseInt(hex.slice(5, 7), 16) / 255;

  const max = Math.max(r, g, b);
  const min = Math.min(r, g, b);
  const l = (max + min) / 2;

  if (max === min) return { h: 0, s: 0, l: l * 100 };

  const d = max - min;
  const s = l > 0.5 ? d / (2 - max - min) : d / (max + min);

  let h = 0;
  if (max === r) h = ((g - b) / d + (g < b ? 6 : 0)) / 6;
  else if (max === g) h = ((b - r) / d + 2) / 6;
  else h = ((r - g) / d + 4) / 6;

  return { h: h * 360, s: s * 100, l: l * 100 };
}

export function getAllocationColor(index: number): string {
  const colorIndex = index % ALLOCATION_COLORS.length;
  const cycle = Math.floor(index / ALLOCATION_COLORS.length);

  if (cycle === 0) return ALLOCATION_COLORS[colorIndex];

  const { h, s, l } = hexToHsl(ALLOCATION_COLORS[colorIndex]);
  const adjustedS = Math.max(MIN_SATURATION, s - cycle * SATURATION_STEP);
  const adjustedL = Math.max(MIN_LIGHTNESS, l - cycle * LIGHTNESS_STEP);

  return `hsl(${Math.round(h)}, ${Math.round(adjustedS)}%, ${Math.round(adjustedL)}%)`;
}
